import config from '../../dashboard_config.json';

const { localStorageKey: BASE_STORAGE_KEY, maxReports: MAX_REPORTS } = config.dashboard.streamReports.history;

const getStorageKey = (companyId) => {
    if (!companyId) return BASE_STORAGE_KEY; // Fallback for safety, though we aim for isolation
    return `${BASE_STORAGE_KEY}_${companyId}`;
};

export const saveReportToHistory = (sessionData, companyId) => {
    try {
        const STORAGE_KEY = getStorageKey(companyId);
        const history = getReportHistory(companyId);

        // Ensure each report has a unique ID and timestamp
        const report = {
            id: `session_${Date.now()}`,
            timestamp: Date.now(),
            ...sessionData
        };

        const updatedHistory = [report, ...history].slice(0, MAX_REPORTS);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
        window.dispatchEvent(new Event('omnistreamHistoryUpdate'));
        return report;
    } catch (e) {
        console.error('Failed to save report to history:', e);
        return false;
    }
};

export const getReportHistory = (companyId) => {
    try {
        const STORAGE_KEY = getStorageKey(companyId);
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    } catch (e) {
        console.error('Failed to load report history:', e);
        return [];
    }
};

export const deleteReportFromHistory = (reportId, companyId) => {
    try {
        const STORAGE_KEY = getStorageKey(companyId);
        const history = getReportHistory(companyId);
        const updatedHistory = history.filter(r => r.id !== reportId);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedHistory));
        window.dispatchEvent(new Event('omnistreamHistoryUpdate'));
        return true;
    } catch (e) {
        console.error('Failed to delete report:', e);
        return false;
    }
};

export const clearReportHistory = (companyId) => {
    const STORAGE_KEY = getStorageKey(companyId);
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new Event('omnistreamHistoryUpdate'));
};
